import { ThemeConstellation } from '@zillow/constellation';

export default ThemeConstellation.ns().breakpoints;
